<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <section>
    <div class="background"></div>
    <!-- Page Error -->
    <app-page-retrieval-error
      *ngIf="pageRetrievalError"
    ></app-page-retrieval-error>

    <div class="content-wrapper">
      <h1 class="title">Student Life</h1>
      <div class="seperator"></div>

      <div class="controls">
        <!-- Filter bar -->
        <app-filter-bar
          *ngIf="filters"
          [filterItems]="filters"
          (filterChange)="onFilterChange($event)"
        ></app-filter-bar>
        <app-sort-by-modal
          *ngIf="!isMobile"
          class="ml-auto"
          (emitSelectedSort)="sortArticlesBy($event)"
        ></app-sort-by-modal>
      </div>

      <div class="article-wrapper">
        <!-- Sort by Modal -->
        <app-sort-by-modal
          *ngIf="isMobile"
          class="ml-auto flex-full-len"
          (emitSelectedSort)="sortArticlesBy($event)"
        ></app-sort-by-modal>
        <!-- Student life Article cards -->
        <ng-container *ngFor="let article of this.filteredArticleCards">
          <div class="card-wrapper">
            <!-- Video or Image -->
            <div class="heading-display">
              <img
                class="header-image"
                *ngIf="article.card_image?.data?.attributes?.url"
                [src]="article.card_image?.data?.attributes?.url"
              />

              <app-youtube-video
                [studentLifeCardSize]="true"
                [videoId]="article.video_id"
              ></app-youtube-video>
            </div>

            <!-- Article Title -->
            <h2 class="article-title">{{ article.title }}</h2>
            <!-- Excerpt -->
            <p>{{ processExcerpt(article.excerpt) }}</p>
            <!-- CTA -->
            <button class="article-cta" (click)="onOpenArticle(article.uid)">
              {{ article.cta_text }}
              <img src="assets/icons/read_now_icon.svg" />
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </section>
</div>
